var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-clock",
    clipPath: "url(#clip0_2600_9617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.375 8.12488H10.3125V9.88738L11.8375 10.7686L11.3688 11.5811L9.375 10.4311V8.12488ZM11.875 4.99988H3.125V11.8749H6.04375C5.775 11.3061 5.625 10.6686 5.625 9.99988C5.625 8.83956 6.08594 7.72676 6.90641 6.90629C7.72688 6.08581 8.83968 5.62488 10 5.62488C10.6687 5.62488 11.3062 5.77488 11.875 6.04363V4.99988ZM3.125 13.1249C2.43125 13.1249 1.875 12.5624 1.875 11.8749V3.12488C1.875 2.43113 2.43125 1.87488 3.125 1.87488H3.75V0.624878H5V1.87488H10V0.624878H11.25V1.87488H11.875C12.2065 1.87488 12.5245 2.00657 12.7589 2.24099C12.9933 2.47541 13.125 2.79336 13.125 3.12488V6.93738C13.9 7.72488 14.375 8.80613 14.375 9.99988C14.375 11.1602 13.9141 12.273 13.0936 13.0935C12.2731 13.9139 11.1603 14.3749 10 14.3749C8.80625 14.3749 7.725 13.8999 6.9375 13.1249H3.125ZM10 6.96863C9.19606 6.96863 8.42505 7.28799 7.85658 7.85646C7.28811 8.42493 6.96875 9.19594 6.96875 9.99988C6.96875 11.6749 8.325 13.0311 10 13.0311C10.3981 13.0311 10.7922 12.9527 11.16 12.8004C11.5278 12.6481 11.8619 12.4248 12.1434 12.1433C12.4249 11.8618 12.6482 11.5277 12.8005 11.1599C12.9528 10.7921 13.0312 10.3979 13.0312 9.99988C13.0312 8.32488 11.675 6.96863 10 6.96863Z",
    fill: "#414148"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2600_9617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClock);
export default __webpack_public_path__ + "static/media/calendar-clock.c19e01313a1298843a72978d5a4c3f5f.svg";
export { ForwardRef as ReactComponent };